<template>
    <div class="text-xs-center pa-4" style="max-height: calc(100vh - 100px); overflow: auto">

        <v-dialog v-model="openOfficerDialog" fullscreen transition="dialog-right-transition" persistent
                  @keydown.esc="cancelOfficerDialog">
            <v-form v-model="valid" lazy-validation ref="form">

                <v-card class="elc-addmember-card">

                    <div style="height: calc(100vh - 50px);overflow-y: auto;">

                        <v-container grid-list-md>

                            <div style="position:relative;">
                                <h2 class="p-10" v-if="!addEditFlag">Add Officer </h2>
                                <h2 class="p-10" v-if="addEditFlag">Update Officer </h2>

                                <v-tooltip bottom style="position:absolute;top: 0;right: 0;">

                                    <v-btn slot="activator" icon @click="cancelOfficerDialog">
                                        <v-icon>clear</v-icon>
                                    </v-btn>

                                    <span>Close</span>

                                </v-tooltip>

                            </div>


                            <v-layout class="justify-space-between" wrap>

                                <v-flex xs12 md3 class="p-10">
                                    <v-select :items="constant.namePrefix" v-model="officer.prefix"
                                              label="Prefix "></v-select>
                                </v-flex>

                                <v-flex xs12 md3 class="p-10">
                                    <v-text-field class="text-capitalize" v-model="officer.fname" :rules="fieldRules"
                                                  label="First Name*"
                                                  required @keypress="isAlphaNumeric"></v-text-field>
                                </v-flex>

                                <v-flex xs12 md3 class="p-10">
                                    <v-text-field v-model="officer.mname" label="Middle Name" @keypress="isAlphaNumeric"
                                    ></v-text-field>
                                </v-flex>

                                <v-flex xs12 md3 class="p-10">
                                    <v-text-field v-model="officer.lname" :rules="fieldRules" label="Last Name*"
                                                  required @keypress="isAlphaNumeric"></v-text-field>
                                </v-flex>

                            </v-layout>

                            <v-layout wrap>

                                <v-flex xs12 md3 class="p-10">

                                    <v-menu
                                            ref="menu"
                                            :close-on-content-click="false"
                                            v-model="menu"
                                            :nudge-right="40"
                                            lazy
                                            transition="scale-transition"
                                            offset-y
                                            full-width
                                            max-width="290px"
                                            min-width="290px"

                                    >
                                        <v-text-field slot="activator" v-model="officer.dob" label="DOB"
                                                      prepend-icon="event"
                                                      readonly @click="dob = parseDate(officer.dob)"
                                        ></v-text-field>

                                        <v-date-picker ref="picker" no-title v-model="dob" @input="menu = false"
                                                       :max="'2015-12-31'"></v-date-picker>

                                    </v-menu>

                                </v-flex>

                                <v-flex xs12 md5 class="p-10">
                                    <v-text-field v-model="officer.email" label="Email"
                                                  required></v-text-field>
                                </v-flex>

                                <v-flex xs2 md1 class="p-10">
                                    <v-text-field label="+91" disabled></v-text-field>
                                </v-flex>

                                <v-flex xs10 md3 class="p-10">
                                    <v-text-field v-model="officer.phone" :mask="mask" label="Mobile*"
                                                  :rules="fieldRules"></v-text-field>
                                </v-flex>

                            </v-layout>

                            <v-layout wrap>
                                <v-flex xs12 md4 class="p-10">
                                    <v-select :items="constant.rolePrefix" v-model="officer.officer_role" label="Role*"
                                              item-text="value" item-value="id" v-if="user.officer_role === 1" readonly
                                              @change="getOfficerHierarchy(officer.officer_role)"
                                    ></v-select>
                                    <v-select :items="constant.rolePrefix" v-model="officer.officer_role" label="Role*"
                                              item-text="value" item-value="id" v-else
                                              @change="getOfficerHierarchy(officer.officer_role)"
                                    ></v-select>
                                </v-flex>
                                <v-flex xs12 md4 class="p-10">
                                    <v-select :items="reportToArr" v-model="officer.report_to" label="Report To*"
                                              item-text="name" :rules="officer.officer_role !==5 ? fieldRules : ''"
                                              :disabled="!reportToFlag"
                                              v-if="user.officer_role === 1" readonly class="text-capitalize"
                                              item-value="officer_id" ref="report_to">
                                        <template slot="item" slot-scope="data">
                                            <span class="elc-capital">   {{ data.item.name }}</span>
                                        </template>
                                    </v-select>
                                    <v-select :items="reportToArr" v-model="officer.report_to" label="Report To*"
                                              item-text="name" :rules="officer.officer_role !==5 ? fieldRules : ''"
                                              :disabled="!reportToFlag" v-else
                                              item-value="officer_id" class="text-capitalize" ref="report_to">
                                        <template slot="item" slot-scope="data">
                                            <span class="elc-capital">   {{ data.item.name }}</span>
                                        </template>
                                    </v-select>
                                </v-flex>
                                <v-flex xs12 md4 class="p-10">
                                    <v-text-field v-model="officer.election_id" label="Election ID"
                                                  :rules="elecIdRules" :mask="maskAlphaNum"
                                                  required></v-text-field>
                                </v-flex>
                            </v-layout>
                            <v-layout wrap
                                      v-if="officer.officer_role==1 ||user.officer_role==1 || officer.officer_role==null">

                                <v-flex xs12 md3 class="p-10">
                                    <v-text-field label="Pincode*" v-model="officer.pincode" mask="######"
                                                  :rules="pinCodeRules" @input="getArea(officer.pincode)"
                                                  required></v-text-field>
                                </v-flex>
                                <v-flex xs12 md3 class="p-10">
                                    <v-text-field v-model="officer.area" label="Area"></v-text-field>
                                </v-flex>
                                <v-flex xs12 md3 class="p-10">
                                    <v-select :items="constant.taluka" label="Taluka*"
                                              v-model="officer.taluka" :rules="fieldRules" required></v-select>
                                </v-flex>
                                <v-flex xs12 md3 class="p-10">
                                    <v-text-field v-model="officer.district" label="District*" :rules="nameRules"
                                                  required></v-text-field>
                                </v-flex>
                            </v-layout>
                            <v-layout wrap v-else-if="officer.officer_role!=1">

                                <v-flex xs12 md3 class="p-10">
                                    <v-text-field label="Pincode*" v-model="officer.pincode" mask="######"
                                                  :rules="pinCodeRules" @input="getArea(officer.pincode)"
                                                  required></v-text-field>
                                </v-flex>
                                <v-flex xs12 md3 class="p-10">
                                    <v-text-field v-model="officer.district" label="District*" :rules="nameRules"
                                                  required></v-text-field>
                                </v-flex>
                            </v-layout>
                            <v-layout wrap>

                                <v-flex xs12 class="p-10 text-sm-right">
                                    <v-btn class="elc-button-radius" @click="cancelOfficerDialog">Cancel</v-btn>
                                    <v-btn class="elc-button-radius-color" v-if="!addEditFlag" @click="addNewOfficer"
                                           :disabled="officer.officer_role === 5 ? officer.fname === '' || officer.lname === '' ||officer.officer_role == null ||officer.phone == '' ||
                                           officer.taluka == null  : officer.fname === '' || officer.lname === '' ||officer.officer_role == null ||officer.phone == '' || !valid ||
                                           officer.report_to == null || officer.taluka == null">
                                        Save
                                    </v-btn>
                                    <!-- :disabled="officer.prefix == null ||officer.fname == '' || officer.lname == '' || officer.dob == null ||officer.email == '' ||officer.officer_role == null ||officer.phone == null || !valid ||
                                           officer.pincode == '' ||officer.area == '' || officer.district == '' ||officer.election_id == '' || officer.report_to == null || officer.taluka == null ">
                                        -->
                                    <v-btn class="elc-button-radius-color" v-if="addEditFlag" @click="updateNewOfficer"
                                           :disabled="!valid"
                                    >Update
                                    </v-btn>
                                </v-flex>
                            </v-layout>

                            <div v-if="loader" class="text-xs-center">
                                <v-progress-circular :size="45" indeterminate color="primary">
                                </v-progress-circular>
                            </div>
                        </v-container>

                    </div>

                </v-card>
            </v-form>
        </v-dialog>
        <alert-modal :alertMsg="msg" :alertMsgDialog="alertDialog" @closeAlert="alertDialog = false"></alert-modal>

    </div>
</template>

<script>
    import moment from 'moment'
    import Common from '../Common/Constants'
    import AlertModal from '../Common/AlertModal'

    export default {
        name: "AddOfficer",
        components: {AlertModal},
        props: ['officerDialog', 'addEditFlag', 'editObj', 'editedObj'],
        data() {
            let self = this;
            return {
                loader: false,
                header: {},
                constant: Common,
                mask: '##### #####',
                maskAlphaNum: 'NNNNNNNNNN',
                valid: false, msg: '',
                alertDialog: false,
                dialog: false,
                nameRules: [
                    v => !!v || 'This field is required',
                    (v) => {
                        if (!v || v.length <= 3)
                            return 'Must be greater than 3 characters';
                        else return true;
                    },
                ],
                fieldRules: [
                    v => !!v || 'This field is required',
                    /*(v) => {
                        if (!v || v.length < 1)
                            return 'This field is required';
                        else return true;
                    }*/
                ],
                emailRules: [
                    v => !!v || 'E-mail is required',
                    v => /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) || 'E-mail must be valid'
                ],
                pinCodeRules: [
                    v => !!v || 'This field is required',
                    (v) => {
                        if (!v || v.length >= 1 && v.length < 6)
                            return 'Must be 6 characters';
                        else return true;
                    }
                ],
                elecIdRules: [
                    (v) => {
                        if (v) {
                            if (v.length > 0 && v.length < 10)
                                return 'Must be 10 characters';
                            else if (v.length > 10)
                                return 'Must be 10 characters';
                            else return true;
                        }
                        else return true;
                    }
                ],
                officer: {
                    prefix: null,
                    fname: '',
                    mname: '',
                    pincode: '',
                    lname: '',
                    phone: '',
                    officer_role: null,
                    election_id: '',
                    dob: null,
                    area: '',
                    district: 'Arvalli',
                    country_code: '',
                    email: '',
                    report_to: '',
                    taluka: '',
                },
                editedObj: {},
                dob: null,
                menu: false,
                successToast: {
                    theme: "primary",
                    position: "top-right",
                    duration: 3000,
                    className: 'success-toast'
                },
                errorToast: {
                    theme: "primary",
                    position: "top-right",
                    duration: 3000,
                    className: 'error-toast'
                },
                areaData: [], pinFlag: false,
                openOfficerDialog: false,
                reportToFlag: false,
                addEditFlag: false, reportToArr: [],
                user: {},
            }
        },
        beforeCreate() {
            this.user = JSON.parse(localStorage.getItem('user'));
        },
        beforeDestroy() {
            console.log("*******beforeDestroy*******", this.editObj)
        },
        destroyed() {
            console.log("*******destroyed*******", this.editObj)
        },
        mounted() {
            let self = this;
            let token = localStorage.getItem('token');
            if (token === '' || token === undefined || token === null) {
                self.$router.push('/')
            }
            self.header = {
                "Content-Type": "application/json",
                "token": token,
            };
            self.openOfficerDialog = this.officerDialog;
            if (self.addEditFlag == true) {
                self.getOfficerHierarchy(self.editObj.officer_role)
                self.editData();
            }
        },
        created() {
            let self = this;
            self.openOfficerDialog = this.officerDialog;
            self.user = JSON.parse(localStorage.getItem('user'));
            if (self.addEditFlag == true) {
                self.editData();
            }
            if (this.user.officer_role === 1) {
                this.getOfficerHierarchy(0);
            }
            console.log("constant.rolePrefix", self.constant.rolePrefix)
        },
        methods: {
            isAlphaNumeric: function (evt) {
                evt = (evt) ? evt : window.event;
                var charCode = (evt.which) ? evt.which : evt.keyCode;
                var ret = (charCode == 32 || (charCode >= 65 && charCode <= 90) || (charCode >= 97 && charCode <= 122));
                if (!ret) {
                    evt.preventDefault();
                } else {
                    return true;
                }
            },
            getOfficerHierarchy(val) {
                let self = this;
                // if (self.user.officer_role === 1 || (self.user.officer_role === 3 && val === 5)) {
                if (self.user.officer_role === 1) {
                    let obj = {};
                    let arr = [];
                    obj = {
                        'officer_id': this.user.officer_id,
                        'name': (!this.user.prefix && !this.user.mname) ? this.user.fname + ' ' + this.user.lname
                            : (this.user.prefix && !this.user.mname) ? this.user.prefix + ' ' + this.user.fname + ' ' + this.user.lname
                                : (!this.user.prefix && this.user.mname) ? this.user.fname + ' ' + this.user.mname + ' ' + this.user.lname
                                    : this.user.prefix + ' ' + this.user.fname + ' ' + this.user.mname + ' ' + this.user.lname
                    };
                    arr.push(obj);
                    self.reportToArr = arr;
                    self.officer.officer_role = val === 5 ? 5 : 0;
                    self.officer.report_to = self.user.officer_id;
                    self.reportToFlag = val !== 5;
                } else if (val === self.user.officer_role - 1) {
                    let obj = {};
                    let arr = [];
                    obj = {
                        'officer_id': this.user.officer_id,
                        'name': (!this.user.prefix && !this.user.mname) ? this.user.fname + ' ' + this.user.lname
                            : (this.user.prefix && !this.user.mname) ? this.user.prefix + ' ' + this.user.fname + ' ' + this.user.lname
                                : (!this.user.prefix && this.user.mname) ? this.user.fname + ' ' + this.user.mname + ' ' + this.user.lname
                                    : this.user.prefix + ' ' + this.user.fname + ' ' + this.user.mname + ' ' + this.user.lname
                    };
                    arr.push(obj);
                    self.reportToArr = arr;
                    self.officer.report_to = self.user.officer_id;
                    self.reportToFlag = true;
                } else {
                    axios.get(self.constant.apiUrl + 'officer/getUserWiseHierarchy')
                        .then(res => {
                            if (res.data.flag) {
                                let arr = [];
                                let obj = {};
                                /* if (val === self.user.officer_role - 1) {
                                     obj = {
                                         'officer_id': self.user.officer_id,
                                         'name': (self.user.mname == null || self.user.mname == '') ? self.user.prefix + ' ' + self.user.fname + ' ' + self.user.lname :
                                             self.user.prefix + ' ' + self.user.fname + ' ' + self.user.mname + ' ' + self.user.lname
                                         // 'name': self.user.prefix + ' ' + self.user.fname + ' ' + self.user.mname + ' ' + self.user.lname
                                     };
                                     arr.push(obj);
                                     self.officer.report_to = self.user.officer_id;
                                 }*/
                                if (val === self.user.officer_role - 2) {
                                    res.data.data.forEach(function (val) {
                                        obj = {
                                            'officer_id': val.officer_id,
                                            'name': (!val.prefix && !val.mname) ? val.fname + ' ' + val.lname
                                                : (val.prefix && !val.mname) ? val.prefix + ' ' + val.fname + ' ' + val.lname
                                                    : (!val.prefix && val.mname) ? val.fname + ' ' + val.mname + ' ' + val.lname
                                                        : val.prefix + ' ' + val.fname + ' ' + val.mname + ' ' + val.lname

                                        };
                                        arr.push(obj)
                                    })
                                }
                                else if (val === self.user.officer_role - 3) {
                                    res.data.data.forEach(function (val) {
                                        if (val.childrenArr) {
                                            val.childrenArr.forEach(function (val1) {
                                                obj = {
                                                    'officer_id': val1.officer_id,
                                                    'name': (!val1.prefix && !val1.mname) ? val1.fname + ' ' + val1.lname
                                                        : (val1.prefix && !val1.mname) ? val1.prefix + ' ' + val1.fname + ' ' + val1.lname
                                                            : (!val1.prefix && val1.mname) ? val1.fname + ' ' + val1.mname + ' ' + val1.lname
                                                                : val1.prefix + ' ' + val1.fname + ' ' + val1.mname + ' ' + val1.lname
                                                };
                                                arr.push(obj)
                                            })
                                        }

                                    })
                                }
                                else if (val === self.user.officer_role - 4) {
                                    res.data.data.forEach(function (val) {
                                        if (val.childrenArr) {
                                            val.childrenArr.forEach(function (val1) {
                                                if (val1.childrenArr) {
                                                    val1.childrenArr.forEach(function (val2) {
                                                        obj = {
                                                            'officer_id': val2.officer_id,
                                                            'name': (!val2.prefix && !val2.mname) ? val2.fname + ' ' + val2.lname
                                                                : (val2.prefix && !val2.mname) ? val2.prefix + ' ' + val2.fname + ' ' + val2.lname
                                                                    : (!val2.prefix && val2.mname) ? val2.fname + ' ' + val2.mname + ' ' + val2.lname
                                                                        : val2.prefix + ' ' + val2.fname + ' ' + val2.mname + ' ' + val2.lname
                                                        };
                                                        arr.push(obj)
                                                    })

                                                }

                                            })
                                        }

                                    })
                                }
                                else if (val === self.user.officer_role - 5) {
                                    res.data.data.forEach(function (val) {
                                        if (val.childrenArr) {
                                            val.childrenArr.forEach(function (val1) {
                                                if (val1.childrenArr) {
                                                    val1.childrenArr.forEach(function (val2) {
                                                        if (val2.childrenArr) {
                                                            val2.childrenArr.forEach(function (val3) {
                                                                obj = {
                                                                    'officer_id': val3.officer_id,
                                                                    'name': (!val3.prefix && !val3.mname) ? val3.fname + ' ' + val3.lname
                                                                        : (val3.prefix && !val3.mname) ? val3.prefix + ' ' + val3.fname + ' ' + val3.lname
                                                                            : (!val3.prefix && val3.mname) ? val3.fname + ' ' + val3.mname + ' ' + val3.lname
                                                                                : val3.prefix + ' ' + val3.fname + ' ' + val3.mname + ' ' + val3.lname
                                                                };
                                                                arr.push(obj)
                                                            })

                                                        }

                                                    })

                                                }

                                            })
                                        }

                                    })

                                }
                                self.reportToArr = arr;
                                self.reportToFlag = val !== 5;
                                /* if (val === 5) {
                                     // self.$refs.report_to.reset();
                                     self.report_to = ''
                                 }*/

                            } else {
                                self.$toasted.show(res.data.message, self.errorToast);
                            }
                        })
                }

            },
            editData() {
                let self = this;
                self.officer = {
                    prefix: self.editObj.prefix,
                    fname: self.editObj.fname,
                    mname: self.editObj.mname,
                    lname: self.editObj.lname,
                    pincode: self.editObj.pincode,
                    phone: self.editObj.phone,
                    officer_role: self.editObj.officer_role,
                    election_id: self.editObj.election_id,
                    dob: self.editObj.dob == 0 ? null : self.editObj.dob,
                    area: self.editObj.area,
                    taluka: self.editObj.taluka,
                    district: self.editObj.district,
                    // country_code: self.editObj.country_code,
                    email: self.editObj.email,
                    officer_id: self.editObj.officer_id,
                    report_to: self.editObj.report_to

                };
                console.log("self.officer ** ", self.officer)
            },
            getArea(data) {
                let self = this;
                if (data.length == 6) {
                    axios.get(self.constant.apiUrl + 'getTerritory/' + data)
                        .then(res => {
                            if (res.data.flag) {
                                self.areaData = res.data.data;
                                self.officer.area = self.areaData.area;
                                self.officer.taluka = self.areaData.taluka;
                                // self.pinFlag = true
                            } else {
                                self.officer.area = '';
                                self.officer.taluka = ''
                            }
                        })
                }
            },
            addNewOfficer() {
                let self = this;
                self.loader = true;
                if (this.valid) {
                    let request = Object.assign({}, this.officer);
                    request.role = this.officer.officer_role;
                    delete this.officer.officer_role;
                    axios.post(Common.apiUrl + 'officer/create', request)
                        .then(res => {
                            if (res.data.flag) {
                                self.$toasted.show('Officer Added', self.successToast);
                                self.cancelOfficerDialog();
                                self.$emit('saveOfficer')
                                // self.$router.push('/OfficerDetails');
                            }
                            else {
                                this.officer.officer_role = request.role;
                                self.alertDialog = true;
                                self.msg = '';
                                self.msg = res.data.message;
                                // self.msg = "Please fill all details";
                                // self.$toasted.show(res.data.message, self.errorToast);
                            }
                            self.loader = false;
                        })
                        .catch((handle) => {
                            self.loader = false;
                            this.officer.officer_role = request.role;
                            self.alertDialog = true;
                            self.msg = '';
                            self.msg = "Please fill all details";
                            self.$toasted.show('Something went wrong', self.errorToast);
                        })
                } else {
                    self.loader = false;
                    self.alertDialog = true;
                    self.msg = '';
                    self.msg = "Please fill all details";
                }

            },
            updateNewOfficer() {
                let self = this;
                self.addEditFlag = true;
                self.editedObj = self.officer;
                self.editedObj.country_code = '+91';
                self.$emit('updateOfficer', self.editedObj)
            },
            cancelOfficerDialog() {
                let self = this;
                self.addEditFlag = false;
                self.openOfficerDialog = false;
                self.officer = {};
                self.dob = null;
                self.$refs.form.reset();
                self.$emit('closeOfficerDialog')
                // self.$destroy();
            },
            goBack() {
                this.$router.push('/officers')
            },
            formatDate(date) {
                if (!date) return null;
                const [year, month, day] = date.split('-');
                return `${day}-${month}-${year}`

            }
            ,
            parseDate(date) {
                if (!date) return null;
                const [day, month, year] = date.split('-');
                return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
            }
        },
        watch: {
            menu(val) {
                val && this.$nextTick(() => (this.$refs.picker.activePicker = 'YEAR'))
            },
            dob() {
                this.officer.dob = this.formatDate(this.dob);
            }
        },
        computed: {
            computedDateFormatted() {
                return this.formatDate(this.dob)
            }
        },
    }
</script>

<style scoped>
    .v-text-field__slot label {
        left: 20px !important;
    }
</style>



// WEBPACK FOOTER //
// src/components/Officer/AddOfficer.vue